import { StyledTabProps } from '../types';
import { Tabs, Tab, styled } from '@mui/material';

const StyledTabs = styled(Tabs)({
    '& .MuiTabs-indicator': {
        color:'#333333',
        backgroundColor: '#3333338c',
    },
});

const StyledTab = styled((props: StyledTabProps) =>
    <Tab disableRipple {...props} iconPosition="start" />)(
        ({ theme }) => ({
            textTransform: 'none',
            minWidth: 0,
            [theme.breakpoints.up('sm')]: {
                minWidth: 0,
            },
            minHeight:'50px',
            margin:'0',
            padding: "0px 20px",
            fontWeight: theme.typography.fontWeightRegular,
            marginRight: theme.spacing(1),
            color: '#333333',
            fontSize: '14px',
            '&:hover': {
                color: '#333333',
                opacity: .9,
            },
            '&.Mui-selected': {
                color: '#333333',
                fontWeight: theme.typography.fontWeightMedium,
            },
            '&.MuiTabs-indicator': {
                backgroundColor: '#333333',
            },
            '&.Mui-focusVisible': {
                backgroundColor: '#333333',
            },
        }),
    );

export { StyledTabs, StyledTab }